const Insurance = Object.freeze({
  INSURANCE: 'assurance',
  ADVANCE: 'avance',
  OTHER: 'autre',
  NO: 'non',
})

export default Insurance
